const api_key = `?api_key=${process.env.REACT_APP_TMDB_API_KEY}`;
const root_endpoint = "https://api.themoviedb.org/3";
const sampleName = "Portrait of a Lady on Fire";
const sampleId = 531428;

const options = {
  method: "GET",
  headers: {
    accept: "application/json",
    Authorization: `Bearer ${process.env.REACT_APP_TMDB_BEARER_TOKEN}`,
  },
};

async function getDb(endpoints) {
  //return json
  try {
    const response = await fetch(endpoints, options);
    const json = await response.json();
    return json;
  } catch (e) {
    console.log("type_of_info: " + e + "endpoints: " + endpoints);
  }
}

async function test_getDb() {
  const x =
    root_endpoint +
    "/configuration/countries" +
    api_key +
    "&countries,languages";
  //"&append_to_response=credits,images,videos";
  console.log(x);
  const test_data = await getDb(x);
  console.log(test_data);
  console.log(Object.keys(test_data));
  let y = test_data.results[0];
  console.log(y);
  console.log(Object.keys(y));
}

//test_getDb();

const pathEndpoints = {
  getMovieDetails: "/movie/{movie_id}",
  getMovieCredits: "/movie/{movie_id}/credits",
  getMovieImages: "/movie/{movie_id}/images",
  getMovieVideos: "/movie/{movie_id}/videos",
  getMovieKeywords: "/movie/{movie_id}/keywords",
  getMovieRcm: "/movie/{movie_id}/recommendations",
  getMovieWatchProviders: "/movie/{movie_id}/watch/providers",
  getConfigLanguage: "/configuration/languages",
  getConfigCountry: "/configuration/countries",
  getMovieGenreList: "/genre/movie/list",
  getTVGenreList: "/genre/tv/list",
  discoverMovie: "/discover/movie",
  discoverTV: "/discover/tv",
  searchKeywords: "/search/keyword",
  searchMulti: "/search/multi",
  getCollection: "/collection/{collection_id}",
  getTvDetails: "/tv/{movie_id}",
  getTvCredits: "/tv/{movie_id}/credits",
  getSeasonDetail: "/tv/{series_id}/season/{season_number}",
  getEpisodeDetail: "/tv/{series_id}/season/{season_number}/episode/{episode_number}",
  getTrendingMov: "/trending/movie/week",
  getTrendingTv: "/trending/tv/week"
};

export async function getCollection(id) {
  const endpoints =
    root_endpoint +
    pathEndpoints["getCollection"].replace("{collection_id}", id) +
    api_key;
  const data = await getDb(endpoints);
  return data;
}
//getSeason Function
export async function getSeason(serieId, seasonNumber) {
  const endpoints =
    root_endpoint +
    pathEndpoints["getSeasonDetail"]
      .replace("{series_id}", serieId)
      .replace("{season_number}", seasonNumber) +
    "?append_to_response=credits,images,videos" + api_key;
    const data = await getDb(endpoints);
    return data;
}

//getEpisode Function
export async function getEpisode(serieId, seasonNumber, episodeNumber){
  const endpoints =
    root_endpoint +
    pathEndpoints["getEpisodeDetail"]
      .replace("{series_id}", serieId)
      .replace("{season_number}", seasonNumber)
      .replace("{episode_number}", episodeNumber) +
    "?append_to_response=credits,images,videos" + api_key;
    const data = await getDb(endpoints);
    return data;
}

//getConfig function
async function getConfig(type_of_config) {
  const endpoints = root_endpoint + pathEndpoints[type_of_config] + api_key;
  const data = await getDb(endpoints);
  return data;
}
//getGenreList function
async function getGenreList(type_of_list = "getMovieGenreList") {
  const endpoints = root_endpoint + pathEndpoints[type_of_list] + api_key;
  try {
    const data = await getDb(endpoints);
    const genreList = data.genres;
    return genreList;
  } catch (err) {
    console.log("getGenreListError: " + err);
  }
}
//getTrending function
async function getTrending(type_of_content){
  const endpoints = root_endpoint + pathEndpoints[`getTrending${type_of_content}`] + api_key;
  try {
    const data = await getDb(endpoints);
    return data.results;
  }catch(err){
    console.log("getTrendingError: " + err)
  }
}


export {
  api_key,
  root_endpoint,
  sampleId,
  sampleName,
  getDb,
  pathEndpoints,
  getConfig,
  getGenreList,
  getTrending
};
